import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@knockrentals/knock-shared-web-v2';
import CustomLink from './CustomLink';
import { CUSTOM_LINK_FIELDS } from '../../../../../../constants';
import { CUSTOM_LINK_DIALOG, CUSTOM_LINK_DIALOG_MODES } from './constants';

const { TITLE, URL } = CUSTOM_LINK_FIELDS;

const CustomLinkDialog = ({ closeDialog, isOpen, link, updateCustomLinks }) => {
  const { linkIndex = -1, [TITLE]: title, [URL]: url } = link || {};

  const mode =
    linkIndex === -1
      ? CUSTOM_LINK_DIALOG_MODES.ADD
      : CUSTOM_LINK_DIALOG_MODES.EDIT;

  const dialogTitle = CUSTOM_LINK_DIALOG[mode].TITLE;
  const primaryButtonText = CUSTOM_LINK_DIALOG[mode].PRIMARY_BUTTON_TEXT;

  const onSaveCustomLink = (customLink) => {
    updateCustomLinks(customLink, linkIndex);
  };

  return (
    <Dialog
      onClose={closeDialog}
      open={isOpen}
      size="xs"
      title={dialogTitle}
      TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
      withCloseIcon
    >
      <CustomLink
        closeDialog={closeDialog}
        onSaveCustomLink={onSaveCustomLink}
        primaryButtonText={primaryButtonText}
        title={title}
        url={url}
      />
    </Dialog>
  );
};

CustomLinkDialog.propTypes = {
  closeDialog: PropTypes.func,
  isOpen: PropTypes.bool,
  link: PropTypes.shape({
    linkIndex: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  updateCustomLinks: PropTypes.func,
};

export default CustomLinkDialog;
